import {
    EMPLOYEE_CONTRACT_TYPE,
    EMPLOYEE_GENDER,
    EMPLOYEE_MARRIAGE_STATUS,
} from '@/modules/Employee/constants'
import dayjs from 'dayjs'
import { TFunction } from 'i18next'

export const getEmployeeTypeLabel = (
    t: TFunction<'translation'>,
    value?: string | null
) => {
    if (!value) return '-'
    return (
        EMPLOYEE_CONTRACT_TYPE(t).find((opt) => opt.value === value)?.label ??
        '-'
    )
}

export const getEmployeeGenderLabel = (
    t: TFunction<'translation'>,
    value?: string | null
) => {
    if (!value) return '-'
    return EMPLOYEE_GENDER(t).find((opt) => opt.value === value)?.label ?? '-'
}

export const getEmployeeMarriageLabel = (
    t: TFunction<'translation'>,
    value?: string | null
) => {
    if (!value) return '-'
    return (
        EMPLOYEE_MARRIAGE_STATUS(t).find((opt) => opt.value === value)?.label ??
        '-'
    )
}

export const EMPLOYEE_GENDER_OPTIONS = (t: TFunction<'translation'>) =>
    EMPLOYEE_GENDER(t)
export const EMPLOYEE_MARRIAGE_OPTIONS = (t: TFunction<'translation'>) =>
    EMPLOYEE_MARRIAGE_STATUS(t)
export const getSeniority = (
    start?: string | Date | null,
    t?: TFunction<'translation'>
) => {
    if (!start) return '-'
    const d = dayjs(start)
    if (!d.isValid()) return '-'

    const now = dayjs()
    if (d.isAfter(now)) return '-'

    const years = now.diff(d, 'year')
    const months = now.diff(d.add(years, 'year'), 'month')
    const days = now.diff(d.add(years, 'year').add(months, 'month'), 'day')

    if (!t) {
        if (years > 0 && months > 0) return `${years} năm ${months} tháng`
        if (years > 0) return `${years} năm`
        if (months > 0) return `${months} tháng`
        return `${days} ngày`
    }

    if (years > 0 && months > 0)
        return `${years} ${t('year')} ${months} ${t('month')}`
    if (years > 0) return `${years} ${t('year')}`
    if (months > 0) return `${months} ${t('month')}`
    return `${days} ${t('day')}`
}
